import React from 'react';
import { connect } from 'react-redux';
import clsx from 'clsx';

// selectors
import {
  isGCSMember,
  hasMemberInfoArrived
} from 'src/universal/redux/cardMemberInfo';
import { shouldShowDynamicAppVac } from 'page_modules/business-vac/redux';
import { isG169Variant } from 'src/universal/components/Experiments/G169/redux';
import { isG176Variant } from 'src/universal/components/Experiments/G176/redux';
import { hasOneXpDataArrived } from 'src/universal/redux/oneXp';
import G169Hero from 'src/universal/components/Experiments/G169/index.js';
import G176Hero from 'src/universal/components/Experiments/G176/index.js';

// components
import DynamicHero from './DynamicHero';
import DynamicAppVacHero from './DynamicAppVacHero';

// styles
import styles from './index.scss?modules';

const PlaceHolder = () => {
  return (
    <div
      style={{ minHeight: '320px', border: 0, brackgroundColor: 'transparent' }}
    />
  );
};

const Hero = ({
  isGCS,
  hasMemberInfoArrived,
  shouldShowDynamicApp,
  isG169,
  isG176,
  oneXpArrived,
  ...restProps
}) => {
  const needToRenderTabbedHero = isGCS && hasMemberInfoArrived;

  let showG169Hero = false;
  let showG176Hero = false;
  let ProspectHero = DynamicAppVacHero;

  if (oneXpArrived && isG176 && shouldShowDynamicApp) {
    showG176Hero = true;
    ProspectHero = G176Hero;
  } else if (oneXpArrived && isG169 && shouldShowDynamicApp) {
    showG169Hero = true;
    ProspectHero = G169Hero;
  } else if (!oneXpArrived) {
    ProspectHero = PlaceHolder;
  }

  return (
    <div
      className={clsx('section-background', 'vac-hero', {
        hasTabbedHero: needToRenderTabbedHero,
        [styles.showG169Hero]: showG169Hero,
        [styles.showG176Hero]: showG176Hero
      })}
    >
      {shouldShowDynamicApp ? (
        <ProspectHero />
      ) : (
        <React.Fragment>
          <div className={styles.backgroundImageHolder} />
          <DynamicHero {...restProps} />
        </React.Fragment>
      )}
    </div>
  );
};

const mapStateToProps = state => {
  return {
    hasMemberInfoArrived: hasMemberInfoArrived(state),
    isGCS: isGCSMember(state),
    shouldShowDynamicApp: shouldShowDynamicAppVac(state),
    oneXpArrived: hasOneXpDataArrived(state),
    isG169: isG169Variant(state),
    isG176: isG176Variant(state)
  };
};

export default connect(mapStateToProps)(Hero);
